import {
  ACCOUNT_IS_MERGE_ELIGIBLE_REQUEST,
  ACCOUNT_IS_MERGE_ELIGIBLE_SUCCESS,
  ACCOUNT_IS_MERGE_ELIGIBLE_FAILURE,
} from '../actions/account';

const initialState = {
  status: {},
  statusResponse: {},
  preferences: {},
  prefOrigin: {},
  showMergeAccountBanner: false,
  huid: '',
};

export default function supplemental(state = initialState, action = null) {
  // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
  switch (action.type) {
    case ACCOUNT_IS_MERGE_ELIGIBLE_REQUEST:
      return Object.assign({}, state, {status: ACCOUNT_IS_MERGE_ELIGIBLE_REQUEST});
    case ACCOUNT_IS_MERGE_ELIGIBLE_SUCCESS:
      return Object.assign({}, state, {
        status: ACCOUNT_IS_MERGE_ELIGIBLE_SUCCESS,
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        showMergeAccountBanner: action.payload.showMergeAccountBanner,
        // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
        huid: action.payload.huid,
      });
    case ACCOUNT_IS_MERGE_ELIGIBLE_FAILURE:
      return Object.assign({}, state, {status: ACCOUNT_IS_MERGE_ELIGIBLE_FAILURE});

    default:
      return state;
  }
}
